import React from 'react';
import './index.scss';
import ReactDOM from 'react-dom/client';
import App from './components/app/App.jsx';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
);

